import { ChatIcon, DocumentIcon } from 'components/Icons';
import AssembleiaCard from 'components/__ASSOCIADO__/AssembleiaCard';
import AssembleiaDocs from 'components/__ASSOCIADO__/AssembleiaDocs';
import VideoPlayer from 'components/__ASSOCIADO__/Associado/VideoPlayer';
import DuvidasFrequentes from 'components/__ASSOCIADO__/DuvidasFrequentes';
import PageSubtitle from 'components/__ASSOCIADO__/PageSubtitle/PageSubtitle';
import AssembleiaDateTime from 'components/__SHARED__/AssembleiaDateTime';
import PageTitle from 'components/__SHARED__/PageTitle/PageTitle';
import { parseISO } from 'date-fns';
import { dispatchToAllYouTubeVideos, isMobile } from 'helpers/utils/HTMLUtils';
import translation from 'locales/translation';
import { Col, Row } from 'plataforma-fundacao-componentes';
import { Fragment, useContext } from 'react';
import Context from './Context';
import BotaoFlutuante from './components/BotaoFlutuante';
import useStyle from './style';

import styles from './styles.module.scss';

export default function PreAssembleia() {
  const classes = useStyle();
  const {
    currentEvent,
    usuario,
    hasPermissionVideos,
    hasPermissionDocumentos,
    hasPermissionDuvidas,
  } = useContext(Context);

  return (
    <Fragment>
      <Row className={styles.preAssembly}>
        <Col cols={[12, 6, 6, 6, 6]}>
          <Row>
            <Col cols={[12, 12, 12, 12, 12]}>
              <header className={classes.info}>
                <PageTitle title={currentEvent!.nome} />
                <PageSubtitle
                  subtitle={translation.AssembleiaAssociadoRoute.subtitlePre}
                />
                {currentEvent?.dataEvento && (
                  <AssembleiaDateTime
                    date={parseISO(currentEvent.dataEvento)}
                  />
                )}
              </header>
            </Col>
            <Col cols={[12, 12, 12, 12, 12]} className={styles.videoContainer}>
              <Row>
                {hasPermissionVideos &&
                  currentEvent!.videos.map((video) => (
                    <Col cols={[12, 12, 6, 6, 6]}>
                      <div className={styles.videoCard}>
                        <VideoPlayer
                          id={String(video.oidVideo)}
                          key={String(video.oidVideo)}
                          blockRedirect={true}
                          url={video.urlYoutube}
                          callBackStarted={(id) => {
                            dispatchToAllYouTubeVideos(
                              'pauseVideo',
                              String(id)
                            );
                          }}
                        />
                        <div className={styles.videoDescription}>
                          {video.descricao}
                        </div>
                      </div>
                    </Col>
                  ))}
              </Row>
            </Col>
          </Row>
        </Col>
        {hasPermissionDuvidas && !isMobile() && (
          <Col cols={[12, 6, 6, 6, 6]} className={classes.topContent}>
            <DuvidasFrequentes evento={currentEvent!} associado={usuario!} />
          </Col>
        )}
        {hasPermissionDocumentos && (
          <Col>
            <AssembleiaCard
              title={translation.AssembleiaAssociadoRoute.files}
              icon={<DocumentIcon />}
            >
              <AssembleiaDocs />
            </AssembleiaCard>
          </Col>
        )}
        {hasPermissionDuvidas && isMobile() && (
          <BotaoFlutuante icon={<ChatIcon />} />
        )}
      </Row>
    </Fragment>
  );
}
